import React, {useState} from "react"
import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";
import logo from "../../../../../common/src/assets/img/brand/logo.svg"
import ConditionalContent from "../../../auth/ConditionalContent";
import {Role} from "../../../auth/roles";


const Drawer = () => {
    const {t} = useTranslation();

    return (
        <aside className="aside is-placed-left is-expanded">
            <div className='logo-container'>
                <img src={logo} alt="Logo"/>
            </div>

            <div className="menu is-menu-main">

                <ConditionalContent
                    hasOneOfRequiredRoles={[Role.AUDIT_READ, Role.ADMIN_GROUPS, Role.ADMIN_USERS, Role.DATALAKE_ACCESS, Role.DATASET_CREATE, Role.DATASET_DELETE, Role.DATASET_PUBLISH]}>
                    <p className="menu-label">{t("dashboards.menuLabel")}</p>
                    <ul className="menu-list">
                        <li>
                            <NavLink to="/dashboards">
                                <span className="icon"><i className="fz fz-desktop"/></span>
                                <span
                                    className="menu-item-label">{t('drawer.dashboard')}</span>
                            </NavLink>
                        </li>
                    </ul>
                </ConditionalContent>
                <ConditionalContent hasOneOfRequiredRoles={[
                    Role.DATALAKE_ACCESS, Role.DATASET_CREATE, Role.DATASET_DELETE, Role.DATASET_PUBLISH]}>

                    <p className="menu-label">{t("drawer.data")}</p>
                    <ul className="menu-list">
                        <li>
                            <NavLink to="/dataset">
                                <span className="icon"><i className="fz fz-binoculars"/></span>
                                <span
                                    className="menu-item-label">{t('drawer.dataset')}</span>
                            </NavLink>
                        </li>
                    </ul>
                </ConditionalContent>
                <ConditionalContent hasOneOfRequiredRoles={[Role.ADMIN_GROUPS, Role.ADMIN_USERS]}>

                    <p className="menu-label">{t("user.management")}</p>
                    <ul className="menu-list">
                        <ConditionalContent hasOneOfRequiredRoles={[Role.ADMIN_USERS]}>

                            <li>
                                <NavLink to="/users">
                                    <span className="icon"><i className="fz fz-book-user"/></span>
                                    <span
                                        className="menu-item-label">{t('drawer.users')}</span>
                                </NavLink>
                            </li>
                        </ConditionalContent>

                        <ConditionalContent hasOneOfRequiredRoles={[Role.ADMIN_GROUPS]}>

                            <li>
                                <NavLink to="/groups">
                                    <span className="icon"><i className="fz fz-users"/></span>
                                    <span
                                        className="menu-item-label">{t('drawer.groups')}</span>
                                </NavLink>
                            </li>
                        </ConditionalContent>

                    </ul>
                </ConditionalContent>
                <ConditionalContent hasOneOfRequiredRoles={[Role.AUDIT_READ]}>

                    <p className="menu-label">{t("drawer.audit")}</p>
                    <ul className="menu-list">
                        <li>
                            <NavLink to="/audit">
                                <span className="icon"><i className="fz fz-history"/></span>
                                <span
                                    className="menu-item-label">{t('drawer.audit_log')}</span>
                            </NavLink>
                        </li>
                    </ul>
                </ConditionalContent>

            </div>
        </aside>
    )
}

export default Drawer
